import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { motion ,AnimatePresence} from "framer-motion";

function Contact() {
 const [showSuccessModal, setShowSuccessModal] = useState(false);
   const [loading, setLoading] = useState(false);
    const [formType, setFormType] = useState(""); // stores which button opened the form
const [contactForm, setContactForm] = useState({
  fullname: "",
  company: "",
  website: "",
  email: "",
  phone: "",
  message: "",
});
const handleContactChange = (e) => {
  const { name, value } = e.target;
  setContactForm((prev) => ({ ...prev, [name]: value }));
};


const isBusinessEmail = (email) => {
  const freeDomains = [
    "gmail.com",
    "yahoo.com",
    "hotmail.com",
    "outlook.com",
    "aol.com",
    "icloud.com",
    "mail.com",
    "live.com"
  ];
  const domain = email.split("@")[1]?.toLowerCase();
  if (!domain) return false;
  return !freeDomains.includes(domain);
};


const handleContactSubmit = async (e) => {
  e.preventDefault();
 
  setLoading(true); // show loading message
  const { fullname, company, website, email, phone, message } = contactForm;


  // Basic validation
  if (!fullname || !email || !message || !company || !phone || !website) {
    alert("Please fill all required fields.");
      setLoading(false); // show loading message

    return;
  }
if (!isBusinessEmail(email)) {
    alert("Please enter a business email, not Gmail/Yahoo/etc.");
      setLoading(false); // show loading message

    return;
  }
 

  try {
        try {
    const emailCheckResponse = await fetch(
      `https://pinakinedgemedia.com/api/validateEmail?email=${email}`
    );
    const emailCheckData = await emailCheckResponse.json();

    if (!emailCheckData.exists) {
      setLoading(false);
      alert("❌ The entered email does not exist. Please use a valid business email.");
      return;
    }
  } catch (err) {
    setLoading(false);
    console.error("Email check failed:", err);
    alert("⚠️ Could not verify email existence. Try again later.");
    return;
  }
    const response = await fetch("https://pinakinedgemedia.com/api/sendContactMail", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
     body: JSON.stringify({
  ...contactForm,
  formType, // ✅ add formType manually here
}),

    });

    if (response.ok) {
       setShowSuccessModal(true);  // ✅ This triggers modal to open
       setLoading(false); // show loading message
       setContactForm({
        fullname: "",
        company: "",
        website: "",
        email: "",
        phone: "",
        message: "",
      });
    } else {
      alert("Error sending message.");
    }
  } catch (err) {
    console.error(err);
    alert("Error sending message.");
  }
};

const [index, setIndex] = useState(0);
 const slides = [
    { text: "Let’s Build Smarter, Stronger B2B Growth — Together" },
    { text: "We’re Just a Conversation Away from Your Next Big Win" },
    { text: "Let’s Build Your Demand Engine — Together" },
  ];

   useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 4500);
    return () => clearInterval(timer);
  }, [slides.length]);

  const currentSlide = slides[index] ?? { text: "" };


  return (
    
    <div>
      <Header />
       <main>

        <AnimatePresence>
  {showSuccessModal && (
    <motion.div
      className="modal-overlay show"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <motion.div
        className="modal show"
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.8, opacity: 0 }}
        transition={{ duration: 0.3 }}
        style={{
          background: "#fff",
          padding: "30px",
          borderRadius: "10px",
          width: "400px",
          textAlign: "center",
          boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
        }}
      >
        <h2 style={{ fontSize: "20px", marginBottom: "10px" }}>
          Message Sent!
        </h2>
        <p>Thank you for contacting us. We will get back to you shortly.</p>
        <button className="vc rg lk gh ml il hi gi _l"
          onClick={() => setShowSuccessModal(false)}
         
        >
          Close
        </button>
      </motion.div>
    </motion.div>
  )}
</AnimatePresence>

 <section className="hero-section herovv1">
      <video
        className="hero-video"
        src="/images/ContactVideo.mp4"
        autoPlay
        muted
        loop
        loading="lazy"
        playsInline
      />

      <div className="hero-overlay" />

      <div className="hero-content">
        <div className="hero-inner">
          <AnimatePresence mode="wait">
            <motion.h1
              key={index}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -30 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
              className="setslidtext"
            >
              {currentSlide.text}
            </motion.h1>
          </AnimatePresence>
        </div>
      </div>
    </section>

     <section className="i ji ii">
       {/* Bg Shapes */}
      <span className="rc h s r vd fd/5 fh rm"></span>
      <img src="/images/shape-08.svg" alt="Shape Bg" className="h q r" />

      {/* Section Title */}
      <div className="animate_top bb ze rj ki xn vq">
        <motion.section
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.8 }}
      ><h2 className="fk vj pr kk wm on/5 gq/2 bb _b">
       Contact Us — Let’s Power Your Pipeline Together
        </h2></motion.section>
        <h3 className="fk tj kk wm bb _b">Turn Intent Into Opportunity. Let’s Start the Conversation. </h3>
      </div>
      <br/>
      <div className="container">
        {/* Left Side - Image */}
         <motion.section
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.8 }}
      >
        <div className="left">
          <img src="/images/cont34.png" alt="Left Side" />
        </div>
</motion.section>
        {/* Right Side - Content */}
        <div className="right">
            <motion.section
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.8 }}
      >
          <p className="uo">
At Pinakinedge Media, we help B2B brands transform data into demand, engagement into revenue, and prospects into lasting relationships. Whether you’re looking to optimize your lead funnel, align marketing and sales, or harness the power of intent data — our team is here to help. Let’s discuss how we can accelerate your growth with a demand generation strategy built for today’s digital-first buyers.         </p>
         </motion.section>
        </div>
      </div>

    </section>
     
      <section id="support" className="i pg fh rm">
          <div className="animate_top bb ze rj ki xn vq">
        <motion.section
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.8 }}
      ><h2 className="fk vj pr kk wm on/5 gq/2 bb _b mk">
       Looking for a B2B marketing provider?
        </h2></motion.section>
      </div>
           <div className="i va bb ye ki xn wq">
             <div className="tc uf sn tf rn un zf xl:gap-10">
               {/* Contact Details */}
               
               <div className="animate_top w-full mn/5 to/3 vk sg hh sm yh rq i pg">
                 <motion.section
             initial={{ opacity: 0, y: 50 }}
             whileInView={{ opacity: 1, y: 0 }}
             viewport={{ once: true, amount: 0.2 }}
             transition={{ duration: 0.8 }}
           >
                 <img src="images/shape-03.svg" alt="Shape" className="h la x wd" />
     
                 <div className="fb">
                   <h4 className="wj kk wm cc mk">Email Address</h4>
                     <p className="jutfy">
                     <a href="mailto:info@pinakinedgemedia.com">info@pinakinedgemedia.com</a>
                   </p>
                 </div>
     
                 <div className="fb">
                   <h4 className="wj kk wm cc mk">Office Location</h4>
                     <p className="jutfy">4283 Express Ln, Suite IN7598, Sarasota, Florida 34249, US</p>
                 </div>
     
                 <div className="fb">
                   <h4 className="wj kk wm cc mk">Phone Number</h4>
                   <p className="jutfy">
                     <a href="tel:91 755 913 6688">+91 755 913 6688</a><br/>
                     <a href="tel:1 912 620 9242">+1 912 620 9242</a><br/>
                     <a href="tel:44 7465 796422">+44 7465 796422</a>
                   </p>
                 </div>
                 <span className="rc nd rh tm lc fb"></span>
     </motion.section>
               </div>
     
               {/* Contact Form */}
               <div className="animate_top w-full nn/5 vo/3 vk sg hh sm yh tq">
                   <motion.section
             initial={{ opacity: 0, y: 50 }}
             whileInView={{ opacity: 1, y: 0 }}
             viewport={{ once: true, amount: 0.2 }}
             transition={{ duration: 0.8 }}
           >
                     <form onSubmit={(e) => handleContactSubmit(e)}>
  <div className="tc sf yo ap zf xi1">
    <div className="vd to/2">
      <label className="rc" htmlFor="fullname">Full name</label>
      <input
        type="text"
        name="fullname"
        id="fullname"
        value={contactForm.fullname}
        onChange={handleContactChange}
        className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
      />
    </div>

    <div className="vd to/2">
      <label className="rc" htmlFor="company">Company</label>
      <input
        type="text"
        name="company"
        id="company"
        value={contactForm.company}
        onChange={handleContactChange}
        className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
      />
    </div>
  </div>

  <div className="tc sf yo ap zf xi1">
    <div className="vd to/2">
      <label className="rc" htmlFor="website">Website</label>
      <input
        type="text"
        name="website"
        id="website"
        value={contactForm.website}
        onChange={handleContactChange}
        className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
      />
    </div>

    <div className="vd to/2">
      <label className="rc" htmlFor="email">Email address</label>
      <input
        type="email"
        name="email"
        id="email"
        value={contactForm.email}
        onChange={handleContactChange}
        className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
      />
    </div>
  </div>

  <div className="tc sf yo ap zf xi1">
    <div className="vd to/2">
      <label className="rc" htmlFor="phone">Phone number</label>
     <input
  type="text"
  name="phone"
  id="phone"
  value={contactForm.phone}
  onChange={(e) => {
    // Allow only digits
    const value = e.target.value.replace(/\D/g, "");
    setContactForm((prev) => ({ ...prev, phone: value }));
  }}
  maxLength={10} // optional: limit to 10 digits
  className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
/>

    </div>
  </div>

  <div className="fb">
    <label className="rc" htmlFor="message">Message</label>
    <textarea
      placeholder="Message"
      rows="3"
      name="message"
      id="message"
      value={contactForm.message}
      onChange={handleContactChange}
      className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 ci"
    ></textarea>
  </div>

  <div className="tc xf">
      <button
  type="submit"
  className="vc rg lk gh ml il hi gi _l"
  disabled={loading}
  onClick={() => {
    setFormType("Contact Page");
  }}
>
  {loading ? "Please wait..." : " Send Message"}
</button>
  </div>
</form>

                 </motion.section>
               </div>
             </div>
           </div>
         </section>
   <br/>
    </main>
      <Footer />
    </div>
  );
}

export default Contact;
